export const CLIENTE: any = {
    'nombre' : '',
    'paterno': '',
    'materno': '',
    'rfc': '',
    'calle': '',
    'noExt': '',
    'noInt': '',
    'colonia': '',
    'municipio': '',
    'cp': '',
    'telefono': '',
    'celular' : '',
    'razonSocial': '',
    'email': '',
    'tipoCliente': 0,
    'contactos': []
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_model/ClienteJson.ts